/** Max length of a partner tag code (`tag_id`), matching the server. */
export const PARTNER_TAG_ID_MAX_LENGTH = 45;
/** Max length of a partner tag display name (`tag`), matching the server. */
export const PARTNER_TAG_NAME_MAX_LENGTH = 100;

export const PARTNER_TAG_ID_SPACE_ERROR = "Tag ID cannot contain spaces.";

/** Tag codes are used in partner systems and URLs, so no whitespace is allowed. */
export const partnerTagIdHasSpace = (tagId: string): boolean =>
  /\s/.test(tagId.trim());

/**
 * Builds the tag code from the display name: trims it, replaces each run of
 * whitespace with "_" and caps it at the server's 45-character limit.
 * e.g. "  Black Hoodie  XL " -> "Black_Hoodie_XL".
 */
export const partnerTagIdFromName = (tag: string): string =>
  tag.trim().replace(/\s+/g, "_").slice(0, PARTNER_TAG_ID_MAX_LENGTH);

export interface PartnerCustomerInventoryTag {
  /** DB row id. Not used in any URL. */
  id: number;
  /** Partner tag code, 1–45 chars. Used in URLs. */
  tag_id: string;
  customer_id: number;
  customer_name: string;
  /** Display name, 1–100 chars. */
  tag: string;
  /** Always 1 in GET responses. */
  active: 0 | 1;
  /** ISO datetime. */
  created_at: string;
  /** ISO datetime. */
  modified_at: string;
}

export interface PartnerCustomerInventoryTagCreateRequest {
  customer_id: number;
  tag_id: string;
  tag: string;
}

/** At least one field is required; `tag_id` and `customer_id` cannot change. */
export interface PartnerCustomerInventoryTagUpdateRequest {
  tag?: string;
  active?: 0 | 1;
}
